module.exports = __webpack_public_path__ + "static/media/2M.b311922e.png";